export default __webpack_public_path__ + "static/media/clarityofmind.efea46d2.png";